/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useMemo,
  useRef,
} from 'react';

const NONEBBOX = { width: 0, height: 0 };
interface DonutChartTooltipProps {
  segmentKey: string;
  position: { x: number; y: number; };
  fontSize: number;
  text: string;
}
function DonutChartTooltip({
  segmentKey,
  position,
  fontSize,
  text,
}: DonutChartTooltipProps): JSX.Element {
  const textRef = useRef<SVGTextElement | null>(null);
  const realPosition = useMemo(() => {
    const {
      width,
      height,
    } = textRef.current?.getBBox() || NONEBBOX;
    return ({
      rectWidth: width + 1.5,
      rectHeight: height + 0.5,
      rectX: position.x - (width / 2),
      rectY: position.y - (height / 2),
      textX: position.x - (width / 2),
      textY: position.y + 0.5,
    });
  }, [textRef.current, position]);
  return (
    <g
      id={segmentKey}
      pointerEvents="none"
    >
      <rect
        x={realPosition.rectX - 0.75}
        y={realPosition.rectY - 0.5}
        width={realPosition.rectWidth}
        height={realPosition.rectHeight}
        rx={0.3}
        ry={0.3}
        fill="white"
        stroke="black"
        strokeWidth="0.07"
      />
      <text
        x={realPosition.textX}
        y={realPosition.textY}
        textAnchor="left"
        style={{
          fontSize,
        }}
        ref={textRef}
      >
        {text}
      </text>
    </g>
  );
}

export default DonutChartTooltip;
